// Shared across App mounts. Reserve the slot before the first await so mount,
// navigation and slow responses cannot each create a MessageBox.
export function createPendingHandoverAlert() {
  let inFlight = false
  const shownFor = new Set()
  return async function check({ key, eligible, load, show, confirm, dismiss }) {
    if (inFlight || shownFor.has(key) || !eligible()) return
    inFlight = true
    try {
      const count = Number(await load())
      // Authentication, route or the dismissal window may change while loading.
      if (!(count > 0) || !eligible() || shownFor.has(key)) return
      shownFor.add(key)
      let accepted = false
      try { await show(count); accepted = true }
      catch (_) { dismiss() }
      if (accepted && eligible()) await confirm()
    } catch (_) {
      // A failed read can be retried on the next navigation.
    } finally { inFlight = false }
  }
}
export const checkPendingHandover = createPendingHandoverAlert()
